export function getLastWallet(): string | null {
  const storageKey = Object.keys(localStorage).find(sk => sk.startsWith('gsw-last'));
  if (storageKey) {
    return localStorage.getItem(storageKey);
  }
  return null;
}
